const locale = {
  'demandList.btn.totalMessage': 'المجموع: {skuTotal} منتجًا فرديًا، {productTotal} منتجًا всего.',
  'demandList.btn.deleteProduct': 'حذف المنتج',
  'demandList.btn.clearQuantity': 'مسح الكمية',
  'demandList.btn.exportSelectedProducts': 'تصدير المنتجات المختارة',
  'demandList.btn.moveToOtherLists': 'نقل إلى قوائم أخرى',

  'demandList.message.deleting': 'جاري الحذف...',
  'demandList.message.deleteSuccessfully': 'تم الحذف بنجاح',
  'demandList.message.deleteFailed': 'فشل الحذف',

  'demandList.message.clearing': 'جاري المسح...',
  'demandList.message.clearQuantitySuccessfully': 'تم مسح الكمية بنجاح',
  'demandList.message.clearQuantityFailed': 'فشل مسح الكمية',

  'demandList.message.exporting': 'جاري التصدير...',
  'demandList.message.exportFailed': 'فشل التصدير',

  'demandList.exported.message': 'تم تصدير المنتجات المختارة',
  'demandList.exported.description': 'يمكنك الاطلاع عليها في ملفات التنزيل في المتصفح.',

  'demandList.title': '< قائمة الطلبات',
  'demandList.inquiry.noproduct': 'الرجاء تحديد منتج',
  'demandList.inquiry.productAllZero': 'الرجاء إدخال رقم المنتج',
  'demandList.inquiry.prompt.title': 'تلميح',
  'demandList.inquiry.quantityprompt.title': 'تلميح',
  'demandList.inquiry.quantityprompt.content':
    'بعض العناصر لديها كمية تساوي 0. سيؤدي الاستمرار في الاستفسار عن العناصر ذات الكمية 0 إلى عدم تقديمها',
  'demandList.inquiry.quantityprompt.ok': 'متابعة الاستفسار',
  'demandList.inquiry.quantityprompt.cancel': 'اكمل',
  'demandList.inquiry.success': 'نجح الاستفسار',
  'demandList.inquiry.check.content':
    'بمجرد التأكيد، سنقوم بالاعتراف بطلب الاستفسار الخاص بك على الفور. سيتم إعلامك بتحديثات المعالجة عبر البريد الإلكتروني أو WhatsApp أو الهاتف',
  'demandList.inquiry.check.clear.content': 'حذف العناصر التي تم تقديمها هذه المرة',
  'demandList.inquiry.check.notclear.content': 'عدم حذف العناصر التي تم تقديمها هذه المرة',
  'demandList.inquiry.textarea.placeholder':
    'إذا لم تجد الإكسسوارات التي تحتاجها أو لديك متطلبات خاصة بالجودة ووقت التسليم، يرجى تحديدها هنا',
  'demandList.inquiry.attachment.filetypeerror': 'تنسيق الملف غير صحيح',
  'demandList.inquiry.attachment.filesizeerror': 'حجم الملف يتجاوز الحد المسموح',
  'demandList.inquiry.attachment.btn': 'تحميل المرفقات',
  'demandList.inquiry.attachment.accepttext':
    'يدعم .pdf، .xlsx، .doc، .png، .jpg. يمكنك تحميل ما يصل إلى 5 ملفات، وكل ملف لا يتجاوز 10 ميجابايت',
  'demandList.inquiry.btn': 'استفسر الآن',
  'demandList.move.title': 'نقل إلى قائمة أخرى',
  'demandList.move.content':
    'بعد الحفظ، سيتم نقل المنتجات المحددة حاليًا إلى قائمة الطلبات المستهدفة. إذا لم تكن القائمة موجودة، يمكنك إنشاؤها بنفسك، بحد أقصى 7 قوائم.',
  'demandList.move.input.placeholder': 'إنشاء قائمة احتياجات، اضغط على Enter للحفظ',
  'demandList.move.unsave': '(غير محفوظ)',
  'demandList.move.select.maxlength': 'تم إنشاء ما يصل إلى 7 عناصر',
  'demandList.move.success': 'تم نقله بنجاح',
  'demandList.versions.current': 'حالي',
  'demandList.versions.deleteprompt.title': 'تأكيد الحذف',
  'demandList.versions.deleteprompt.content':
    'بمجرد حذف قائمة الطلبات، لن تتمكن من استعادتها. هل أنت متأكد من رغبتك في حذفها؟',
  'demandList.versions.edit.title': 'تحرير',
  'demandList.versions.input.placeholder': 'أدخل',

  'demandList.modal.okText': 'تأكيد',
  'demandList.modal.cancelText': 'إلغاء',

  'demandList.modal.title.delete': 'تأكيد حذف المنتجات؟',
  'demandList.modal.content.delete': 'بعد التأكيد، سيتم حذف المنتجات المختارة.',
  'demandList.modal.title.clear': 'تأكيد مسح الكمية؟',
  'demandList.modal.content.clear':
    'بعد التأكيد، سيتم إعادة تعيين الكمية المملوءة للمنتجات المختارة إلى 0.',
};

export default locale;
